import { render } from "./AnoneButton.vue?vue&type=template&id=5bc8c01e&scoped=true"
import script from "./AnoneButton.vue?vue&type=script&lang=js"
export * from "./AnoneButton.vue?vue&type=script&lang=js"

import "./AnoneButton.vue?vue&type=style&index=0&id=5bc8c01e&scoped=true&lang=css"

import exportComponent from "/Users/wadayuki/Desktop/anone/anone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc8c01e"]])

export default __exports__